import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { SCREENS } from '../../constants/tracking/Screens';
import { jsx as _jsx } from "react/jsx-runtime";
const productsConfig = {
  STARTER: {
    apiName: Products.CMS_HUB_STARTER,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.content.starterCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(StarterLowerTierMessage, {})
  },
  PROFESSIONAL: {
    apiName: Products.CMS_HUB_PROFESSIONAL,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.content.professionalCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.professional.lowerTierPlus"
    })
  },
  ENTERPRISE: {
    apiName: Products.CMS_HUB_ENTERPRISE,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.content.enterpriseCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.enterprise.lowerTierPlus"
    })
  }
};
export const ContentHubMerchCards = () => {
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig,
    screen: SCREENS.CONTENT
  });
};